import styles from './ConfiguratorMobile.module.scss';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';
import cn from 'classnames';
import Button from '../../../../ui/Button/Button';
import { formatCurrency } from '../../utils';

export default function Mobile({ stepSelectedItem, step, index, onClickSelectType, onClickStep }) {
  return (
    <div className={styles.wrapper}>
      <h3 className={styles.title}>{step?.title}</h3>
      <div className={styles.image}>
        <Image field={stepSelectedItem?.image} />
      </div>
      <h4 className={styles.subtitle}>Select car model:</h4>
      <ul className={styles.list}>
        {step?.items?.map((item) => {
          return (
            <li
              className={cn(styles.list_item, item.selected && styles.list_item_active)}
              key={item.id}
              onClick={() => onClickSelectType(item.id)}
            >
              <div className={styles.list_item_top}>
                <h4 className={styles.list_item_title}>{item.title}</h4>
                <p className={styles.list_item_price}>
                  {item.priceText || `Starting at ${formatCurrency(item.price, step?.priceUnit)}`}
                </p>
              </div>
              <p className={styles.list_item_text}>{item.text}</p>
            </li>
          );
        })}
      </ul>
      <div className={styles.buttonWrapper}>
        <Button
          className={styles.buttonWrapper_button}
          onClick={() => onClickStep(index + 1)}
          isShowTooltip={false}
        >
          {step?.buttonText || 'Continue'}
        </Button>
      </div>
    </div>
  );
}
